import ChamUpload from './components/features/ChamUpload/ChamUpload';
import VisualizerPage from './components/features/VisualizerPage/VisualizerPage';

function App() {
  return (
    <>
      <VisualizerPage />
      <ChamUpload />
    </>
  );
}

export default App;


